// "Today", "Yesterday", "12 days ago", or "Never" for a user's last_active_at
export default function formatLastActive(isoString) {
  if (!isoString) return 'Never';
  const days = Math.floor((Date.now() - new Date(isoString).getTime()) / 86400000);
  if (days <= 0) return 'Today';
  if (days === 1) return 'Yesterday';
  return `${days} days ago`;
}
